import React from 'react';
import i18next from 'i18next';
import '../../style/Pagination.less';

const Pagination = ({canPreviousPage, gotoPage, canNextPage, pageCount, previousPage, nextPage, pageIndex}) => {

    const pageNumbers = [];
    for (let i = 0; i < pageCount; i++) {
        pageNumbers.push(i + 1);
    }

    return (
        <nav aria-label={i18next.t('Table.PAGINATION')}>
            <ul className="pagination justify-content-center">
                <li className={'page-item' + (!canPreviousPage ? ' disabled' : '')}>
                    <a className="page-link" href="#" aria-label={i18next.t('Table.PREVIOUS')}
                       onClick={() => previousPage()}>
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                {
                    pageNumbers.map(page =>
                        <li className={'page-item' + ((page - 1) === pageIndex ? ' active' : '')} key={page}>
                            <a className="page-link" href="#"
                               onClick={() => gotoPage(page - 1)}>{page}</a>
                        </li>
                    )
                }

                <li className={'page-item' + (!canNextPage ? ' disabled' : '')}>
                    <a className="page-link" href="#" aria-label={i18next.t('Table.NEXT')}
                       onClick={() => nextPage()} disabled={!canNextPage}>
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination;
